import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const CurrentTxnRemarksModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // fields
    remarks, onRemarksChange, remarksError, setRemarksError,
    climeTxnType, onClimeTxnTypeChange, climeTxnTypeList, climeTxnTypeError, setClimeTxnTypeError,
    reconciliationStatus
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add remarks'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    {
      // reconciliationStatus === 'reconcile_failed' &&
      <InputSelectSF type='select' name='climeTxnType' label='Transaction type'
        value={climeTxnType} onChange={onClimeTxnTypeChange} optionList={climeTxnTypeList}
        error={climeTxnTypeError} setError={setClimeTxnTypeError}
      />
    }
    <InputTextAreaSF type='text' name='remarks' label='Internal remarks'
      value={remarks} onChange={onRemarksChange}
      error={remarksError} setError={setRemarksError}
      help='500 characters max'
    />

  </ModalFormUI>

export default CurrentTxnRemarksModalUI
